"use client"

import { Lectern } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LecternIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LecternIcon = component(Icon)({ as: Lectern })
